// Cloudflare image opzimization prefix for supported origins:
// https://developers.cloudflare.com/images/url-format
export const CLOUDFLARE_PREFIX = 'cdn-cgi/image';

export const IMAGE_WIDTHS = [
	375,
	768,
	1024,
	1440,
	1920,
	2800,
];

export function getClosestHigherWidth(width?: number) {
	if (!width) return width;

	const closest = IMAGE_WIDTHS.find((w) => w >= width);

	return closest ?? IMAGE_WIDTHS[IMAGE_WIDTHS.length - 1];
}

export function getAdjustedHeight(height?: number, width?: number, adjustedWidth?: number) {
	if (!height || !width || !adjustedWidth) return height;

	const ratio = width / height;

	return Math.ceil(adjustedWidth / ratio);
}

export const getCloudflareSrc = (origin: string, src: string, options: {
	width?: number;
	height?: number;
	fit?: string;
	shouldContain?: boolean;
	isLossless?: boolean;
	format?: string;
	trim?: string;
	quality?: number | string;
	skipAdjustments?: boolean;
} = {}) => {
	/**
	 * Cloudflare service options: https://developers.cloudflare.com/images/url-format#options
	 * 'format=auto' - picks best supported format (usually webp) via user-agent
	 * 'fit=scale-down' - same as `object-fit: contain` except it doesn't enlarge
	 * 'fit=crop' - same as `object-fit: cover` except it doesn't enlarge (default)
	 */
	const fitValue = options.fit || (options.shouldContain ? 'scale-down' : 'crop');

	const adjustedWidth = options.skipAdjustments ? options.width : getClosestHigherWidth(options.width);
	const adjustedHeight = options.skipAdjustments ? options.height : getAdjustedHeight(options.height, options.width, adjustedWidth);

	const optionString = [
		'format=auto',
		adjustedWidth && `w=${adjustedWidth}`,
		adjustedHeight && `h=${adjustedHeight}`,
		`fit=${fitValue}`,
		options.isLossless && 'q=100', // override default lossy 85
		options.format && `f=${options.format}`,
		options.trim && `trim=${options.trim}`,
		(options.quality && !options.isLossless) && `q=${options.quality}`,
	].filter((param) => !!param).join(',');

	//  Get relative path to image
	let [, path] = src.split(origin);

	// Path usually starts with '/', but can also start with '//' (legacy). Trim it:
	while (path.startsWith('/')) {
		path = path.replace('/', '');
	}

	return `${origin}/${CLOUDFLARE_PREFIX}/${optionString}/${path}`;
};
